<template>
  <div class="is-active-container">
    <div class="is-active-content">
      <span class="is-active-text">{{ displayLabel }}</span>
      <div class="toggle-wrapper" @click="handleToggle">
        <svg v-if="modelValue" xmlns="http://www.w3.org/2000/svg" width="50" height="25" viewBox="0 0 50 25" fill="none">
          <rect x="0.593994" width="49.406" height="24.7742" rx="12.3871" fill="var(--primary-color)" />
          <rect x="27.6875" y="2.32227" width="20.7187" height="20.129" rx="10.0645" fill="white" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="49" height="25" viewBox="0 0 49 25" fill="none">
          <rect width="49" height="25" rx="12.5" fill="#D9D9D9" />
          <rect x="2" y="2" width="21" height="21" rx="10.5" fill="white" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IsActiveComponentV1',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayLabel() {
      return this.label || this.$t('components.dynamicToggle.isActive')
    },
  },
  methods: {
    handleToggle() {
      if (!this.disabled) {
        this.$emit('update:modelValue', !this.modelValue)
        this.$emit('change', !this.modelValue)
      }
    },
  },
}
</script>

<style scoped>
.is-active-container {
  /* width: 579px; */
  width: auto;
  height: 47px;
  flex-shrink: 0;
  border-radius: 6px;
  border: 1px solid #dbdbdb;
  padding: 0 16px;
  display: flex;
  align-items: center;
}

.is-active-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.is-active-text {
  color: #32393e;
  font-family: Archivo;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.16px;
}

.toggle-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.toggle-wrapper.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
